import { IJsonSerializable } from "./interfaces"

import { OpDescr } from "../core/op-descr"

export class OpExportPluginColumn implements IJsonSerializable  {

    // Members

    public idDataTypeFormat: number

    public caption: OpDescr
    public name: string
    public readOnly: boolean
    public tooltip: OpDescr
    public type: any

    // Members End

    
    // Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    // Ctor End

    
    // IJsonSerializable Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj != null) {
            this.idDataTypeFormat = opObj.IdDataTypeFormat

            this.caption = opObj.Caption != null ? new OpDescr(opObj.Caption) : null
            this.name = opObj.Name
            this.readOnly = opObj.ReadOnly
            this.tooltip = opObj.Tooltip != null ? new OpDescr(opObj.Tooltip) : null
            this.type = opObj.Type
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            IdDataTypeFormat: this.idDataTypeFormat,

            Caption: this.caption != null ? this.caption.toJSON() : null,
            Name: this.name,
            ReadOnly: this.readOnly,
            Tooltip: this.tooltip != null ? this.tooltip.toJSON() : null,
            Type: this.type
        }
    }

    // IJsonSerializable Implementation End
}